// extracted by mini-css-extract-plugin
export default {"ColorContainer":"StageColorContainer_ColorContainer__QHp54"};